<template>
  <div id="app">
    <vHeader></vHeader>
    <router-view/>
  </div>
</template>

<script>
  import Header from '@/components/base/header/header.vue'
  import './assets/css/widget.scss';
export default {
  name: 'App',
  components:{
    vHeader:Header ,
  }
}
</script>

<style>
  @import url('./assets/css/common.css');
 #app{
   height: 100%;
   display: flex;
   flex-direction: column;

 }
</style>



// WEBPACK FOOTER //
// src/App.vue